import DestinationSlider from "../blocks/destination-slider";
import GallerySlider from "../blocks/gallery-slider";

const DestinationOpen = {
  init() {
    new DestinationSlider(".reasons .destination-slider");
    new GallerySlider(".destination .gallery");
  },
};

export default DestinationOpen;
